import React, { useEffect, useState, useRef, useCallback } from 'react';
import { connect } from 'react-redux';
import ReactDOM from 'react-dom';
import CountdownTimer from '../../components/CountdownTimer';
import { FINAL_EVENT_STATUS, SESSION_STATE, GO_LIVE_STATES, EVENT_TYPE, AUTH_MODE } from '../../constants';
import { hideLoader } from '../../store/app/actions';
import { getTimeString, getCleanTime } from '../../utils';
import Proceed from '../../components/Proceed';
import { setCountDown } from '../../store/app';
import { ReactComponent as GoogleIcon } from '../../assets/img/googleIcon.svg';
import './welcome.css';
const Welcome = ({
  ctrl,
  setCountDown,
  hideLoader,
  title,
  desc,
  startTime,
  onProceed,
  eventStatus,
  sessionState,
  userDisplayName,
  poster,
  sessionExpired,
  skipForm,
  mode,
  goLive,
  liveDuration,
  showCountdownTimer,
  eventType,
  themeUrl,
  authMode,
  googleLoginRequired,
  googleClientID,
  headless,
}) => {
  const [showCountdown, setShowCountdown] = useState(false);
  const [counterComplete, setCounterComplete] = useState(false);
  const [isPosterImg916, setIsPosterImg916] = useState(false);
  const [forcedUiVisible, setForcedUiVisible] = useState(false);

  const [titleCustoms, setTitleCustoms] = useState();
  const [descCustoms, setDescCustoms] = useState();

  const fontListRef = useRef({
    Roboto: `"Roboto", sans-serif`,
    Macondo: `'Macondo', cursive`,
    Akshar: `'Akshar', sans-serif`,
    Bitstream: 'Bitstream Vera Serif Bold',
  });

  useEffect(() => {
    sessionState === SESSION_STATE.REJECTED && setForcedUiVisible(true);
  }, [sessionState]);

  const getForceUi = (hideForceMessage = false) => {
    return ReactDOM.createPortal(
      <div className={`streamInUse ${!forcedUiVisible ? 'hide' : ''}`}>
        <p style={{ margin: 0 }}>
          <i className="material-icons waring">warning</i>
          This event is currently being used on another device.{' '}
          {hideForceMessage ? '' : 'Would you still like to proceed?'}
        </p>
        {!hideForceMessage && (
          <p className="note">Please Note: On Proceeding, this will forcefully close the event on the other device.</p>
        )}
        <div className="streamAction">
          <div className="streamBtn" onClick={() => setForcedUiVisible(false)}>
            Cancel
          </div>
          <div className="streamBtn" onClick={() => onProceed(true, userDisplayName)}>
            Proceed
          </div>
        </div>
      </div>,
      document.getElementsByClassName('mainDiv')[0],
    );
  };

  const isEventDay = () => {
    const diff = startTime - Date.now();
    const gap = 12 * 60 * 60 * 1000;
    if (diff > gap) {
      return false;
    }
    return true;
  };

  const getBgStyles = () => ({
    background: poster ? `url("${poster}") no-repeat center` : 'black',
  });

  const textStyles = (customs) => {
    return {
      fontFamily: fontListRef.current[customs?.font],
      fontSize: customs?.fontSize,
      fontWeight: customs?.fontWeight,
      fontStyle: customs?.fontItalics ? 'italic' : 'normal',
      textDecoration: customs?.fontUnderline ? 'underline' : 'none',
      color: customs?.fontColor,
    };
  };

  const emailAuthUi = () => {
    return (
      <div className="socialLogin">
        <p>Join the event with your social login</p>
        <button id="googleLogin" className="googleSocial">
          <GoogleIcon />
          <span>sign in with google</span>
        </button>
      </div>
    );
  };

  const getProceedForm = () => {
    const force = sessionState === SESSION_STATE.REJECTED;
    return (
      <>
        <Proceed
          force={force}
          userDisplayName={userDisplayName}
          forcedUiVisible={forcedUiVisible}
          onProceed={onProceed}
          skipForm={skipForm}
        />
        {sessionState === SESSION_STATE.REJECTED && !headless && getForceUi()}
      </>
    );
  };

  const getWelcomeHeading = () => {
    const timeObj = getCleanTime(startTime);
    const timeString = `${timeObj.date} ${timeObj.month.substring(0, 3)}, ${timeObj.day.toUpperCase()}, ${
      timeObj.hour
    }:${timeObj.minute} ${timeObj.ampm} ONWARDS `;

    return (
      <>
        <div className="welcomeHdng">
          <p className="title" style={titleCustoms}>
            {title}
          </p>
          <p className="byline" style={descCustoms}>
            {desc}
          </p>
          <p
            className={`event-date ${goLive === GO_LIVE_STATES.NEVER_LIVE ? (!counterComplete ? '' : 'hide') : 'hide'}`}
          >
            {timeString}
          </p>
        </div>
        <div className="welcomeDivider"></div>
      </>
    );
  };

  const getWaitingMessage = () => {
    if (goLive === GO_LIVE_STATES.PAUSED) {
      if (liveDuration > 10) {
        return <div className="waitMsg">Please wait, live stream will resume shortly</div>;
      }
    }
    return <div className="waitMsg">Please wait, live stream will begin shortly</div>;
  };

  const countdownVisibility = () => {
    const diff = startTime - Date.now();
    const gap = showCountdownTimer;
    if (diff < gap || goLive !== GO_LIVE_STATES.NEVER_LIVE) {
      setShowCountdown(true);
    } else {
      setTimeout(() => {
        setShowCountdown(true);
      }, diff - gap);
    }
  };

  const checkIfPosterImg916 = () => {
    const img = new Image();
    img.onload = function () {
      const aspectRatio = this.width / this.height;
      if (aspectRatio <= 0.6) {
        setIsPosterImg916(true);
      }
    };
    img.src = poster;
  };
  useEffect(() => {
    countdownVisibility();
    checkIfPosterImg916();
    //eslint-disable-next-line
  }, []);

  const getMainComponent = () => {
    if (
      showCountdown &&
      (isEventDay() ||
        eventStatus === FINAL_EVENT_STATUS.RUNNING ||
        eventStatus === FINAL_EVENT_STATUS.PAUSED ||
        goLive === GO_LIVE_STATES.PAUSED)
    ) {
      if (
        eventStatus === FINAL_EVENT_STATUS.NOT_STARTED ||
        goLive === GO_LIVE_STATES.PAUSED ||
        goLive === GO_LIVE_STATES.NEVER_LIVE
      ) {
        return (
          <>
            {getWelcomeHeading()}
            {googleLoginRequired ? (
              emailAuthUi()
            ) : (
              <>
                {sessionState === SESSION_STATE.REJECTED && !headless && getForceUi()}
                <CountdownTimer
                  force={sessionState === SESSION_STATE.REJECTED}
                  purposedTime={startTime}
                  onComplete={() => {
                    setCounterComplete(true);
                  }}
                  endMessage={getWaitingMessage()}
                  setCountDown={setCountDown}
                />
              </>
            )}
          </>
        );
      } else {
        return (
          <>
            {getWelcomeHeading()}
            {(sessionState === SESSION_STATE.REJECTED || skipForm === false || mode === 'portrait') && ''}
            {googleLoginRequired ? emailAuthUi() : getProceedForm()}
          </>
        );
      }
    } else {
      return (
        <>
          {getWelcomeHeading()}
          {googleLoginRequired ? emailAuthUi() : <div className="welcomeScreenTime">{getTimeString(startTime)}</div>}
        </>
      );
    }
  };

  const attachSignIn = useCallback(
    (element) => {
      window.auth2.attachClickHandler(
        element,
        {},
        function (googleUser) {
          let id_token = googleUser.getAuthResponse().id_token;
          ctrl.session.handleUserAuth(id_token);
        },
        function (error) {
          console.log(error);
        },
      );
    },
    [ctrl.session],
  );

  useEffect(() => {
    themeUrl &&
      fetch(themeUrl)
        .then((res) => res.json())
        .then((res) => {
          const { main } = res;
          setTitleCustoms(textStyles(main.titleCustoms));
          setDescCustoms(textStyles(main.descCustoms));
        })
        .catch((err) => console.error('error ocurred', err));
  }, [themeUrl]);

  useEffect(() => {
    if (typeof googleClientID === 'undefined' || googleClientID === '') {
      return;
    }
    googleLoginRequired &&
      authMode === AUTH_MODE.EMAIL &&
      window.gapi.load('auth2', function () {
        try {
          window.auth2 = window.gapi.auth2.init({
            client_id: googleClientID,
            cookiepolicy: 'single_host_origin',
            prompt: 'select_account',
          });
          attachSignIn(document.getElementById('googleLogin'));
        } catch (err) {
          console.error('error occured ', err);
        }
      });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [googleLoginRequired]);

  useEffect(() => {
    hideLoader();
    //eslint-disable-next-line
  }, []);

  return (
    <>
      {eventType === EVENT_TYPE.HLS_RECORDING || headless ? (
        getProceedForm()
      ) : (
        <div className={`welcomeNote ${!(sessionState === SESSION_STATE.REJECTED) && skipForm ? 'skipForm' : ''}`}>
          <div className="welcomePoster">
            <div
              className={`welcomePosterImg ${isPosterImg916 ? 'img-portrait-9-16' : ''}`}
              style={getBgStyles()}
            ></div>
          </div>
          {!sessionExpired && getMainComponent()}
        </div>
      )}
    </>
  );
};

const mapStateToProps = (state) => {
  return {
    title: state.app.title,
    desc: state.app.desc,
    startTime: state.app.welcomeData?.meta.starttime,
    // startTime: Date.now() + 10 * 1000,
    eventStatus: state.app.eventStatus,
    sessionState: state.app.sessionState,
    userDisplayName: state.app.userDisplayName,
    proceedClickCaptured: state.app.proceedClickCaptured,
    sessionExpired: state.app.sessionExpired,
    skipForm: state.app.apiJsonConfig.skipForm,
    mode: state.app.mode,
    goLive: state.app.goLive,
    liveDuration: state.app.liveDuration,
    showCountdownTimer: state.app.apiKeyJson?.conf?.welcomeScreen?.showCountdownTimer,
    eventType: state.app.eventType,
    themeUrl: state.app.welcomeData?.meta.themeurl,
    authMode: state.app.welcomeData?.meta.authmode,
    googleLoginRequired: state.app.googleLoginRequired,
    googleClientID: state.app.apiKeyJson?.info?.googleclientId,
    headless: state.app.config.headless,
  };
};

const mapDispatchToProps = {
  hideLoader,
  setCountDown,
};

export default connect(mapStateToProps, mapDispatchToProps)(Welcome);
